import { Bounce, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function dismiss() {
    toast.dismiss();
}

export function error(message) {
    return toast.error(message, {
        position: 'top-center',
        autoClose: message?.length > 100 ? 15000 : 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        transition: Bounce,
    });
}

export function success(message) {
    return toast.success(message, {
        position: 'top-center',
        autoClose: message?.length > 100 ? 15000 : 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        transition: Bounce,
    });
}
